// src/pages/Home/index.jsx

import React, { useEffect, useState } from "react";
import QlikCard from "shared/components/QlikCard";
import QlikObject from "shared/components/QlikObject";

import "shared/App.css";
import "../../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { initializeIntroTour } from "../../utils/introTour";

export default function HomePage({ title, pageTitle, isAppReady, menuItemsStrings }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);
  const [isHovered, setIsHovered] = useState(false);

  /**
   * When the user clicks “Start Tour,” clear the localStorage flag
   * and immediately re‐invoke initializeIntroTour() so that the tour begins.
   */
  const handleStartTourClick = () => {
    console.log("Button clicked, resetting the tour...");
    localStorage.removeItem("hasCompletedTour");

    // Re‐invoke the helper exactly as in useEffect below:
    initializeIntroTour({
      isAppReady,
      tourHomePage: menuItemsStrings.tourHomePage,
      tourGlobalNavbar: menuItemsStrings.tourGlobalNavbar,
      tourGlobalNavbarTitle: menuItemsStrings.tourGlobalNavbarTitle,
      tourHomeHelpPopup: menuItemsStrings.tourHomeHelpPopup,
      tourHomeHelpPopupTitle: menuItemsStrings.tourHomeHelpPopupTitle,
      tourGlobalAllFilters: menuItemsStrings.tourGlobalAllFilters,
      tourGlobalAllFiltersTitle: menuItemsStrings.tourGlobalAllFiltersTitle,
      tourGlobalCurrentSelections:
        menuItemsStrings.tourGlobalCurrentSelections,
      tourGlobalCurrentSelectionsTitle:
        menuItemsStrings.tourGlobalCurrentSelectionsTitle,
      tourGlobalBookmarkCreate: menuItemsStrings.tourGlobalBookmarkCreate,
      tourGlobalBookmarkCreateTitle:
        menuItemsStrings.tourGlobalBookmarkCreateTitle,
      tourGlobalBookmarkShare: menuItemsStrings.tourGlobalBookmarkShare,
      tourGlobalBookmarkShareTitle:
        menuItemsStrings.tourGlobalBookmarkShareTitle,
      tourHomeBarchart: menuItemsStrings.tourHomeBarchart,
      tourHomeBarchartTitle: menuItemsStrings.tourHomeBarchartTitle,
      tourGlobalFeedback: menuItemsStrings.tourGlobalFeedback,
      tourGlobalFeedbackTitle: menuItemsStrings.tourGlobalFeedbackTitle,
      tourParamsNext: menuItemsStrings.tourParamsNext,
      tourParamsPrev: menuItemsStrings.tourParamsPrev,
      tourParamsDone: menuItemsStrings.tourParamsDone,
      tourParamsOf: menuItemsStrings.tourParamsOf,
      tourParamsTourStartButton:
        menuItemsStrings.tourParamsTourStartButton,
      elementClassMappings: [
        {selector: "button.fb-form__open", className: "tour-global-feedback",timeoutMs: 10000}
      ],
    });
  };

  /**
   * On mount (and whenever isAppReady toggles), attempt to auto‐start the tour.
   * All URL / mediaQuery / localStorage checks happen inside initializeIntroTour().
   */
  useEffect(() => {
    initializeIntroTour({
      isAppReady,
      tourHomePage: menuItemsStrings.tourHomePage,
      tourGlobalNavbar: menuItemsStrings.tourGlobalNavbar,
      tourGlobalNavbarTitle: menuItemsStrings.tourGlobalNavbarTitle,
      tourHomeHelpPopup: menuItemsStrings.tourHomeHelpPopup,
      tourHomeHelpPopupTitle: menuItemsStrings.tourHomeHelpPopupTitle,
      tourGlobalAllFilters: menuItemsStrings.tourGlobalAllFilters,
      tourGlobalAllFiltersTitle: menuItemsStrings.tourGlobalAllFiltersTitle,
      tourGlobalCurrentSelections:
        menuItemsStrings.tourGlobalCurrentSelections,
      tourGlobalCurrentSelectionsTitle:
        menuItemsStrings.tourGlobalCurrentSelectionsTitle,
      tourGlobalBookmarkCreate: menuItemsStrings.tourGlobalBookmarkCreate,
      tourGlobalBookmarkCreateTitle:
        menuItemsStrings.tourGlobalBookmarkCreateTitle,
      tourGlobalBookmarkShare: menuItemsStrings.tourGlobalBookmarkShare,
      tourGlobalBookmarkShareTitle:
        menuItemsStrings.tourGlobalBookmarkShareTitle,
      tourHomeBarchart: menuItemsStrings.tourHomeBarchart,
      tourHomeBarchartTitle: menuItemsStrings.tourHomeBarchartTitle,
      tourGlobalFeedback: menuItemsStrings.tourGlobalFeedback,
      tourGlobalFeedbackTitle: menuItemsStrings.tourGlobalFeedbackTitle,
      tourParamsNext: menuItemsStrings.tourParamsNext,
      tourParamsPrev: menuItemsStrings.tourParamsPrev,
      tourParamsDone: menuItemsStrings.tourParamsDone,
      tourParamsOf: menuItemsStrings.tourParamsOf,
      tourParamsTourStartButton:
        menuItemsStrings.tourParamsTourStartButton,
      elementClassMappings: [
        {selector: "button.fb-form__open", className: "tour-global-feedback",timeoutMs: 10000}
      ],
    });
  }, [isAppReady, menuItemsStrings]);

  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-lg-10">
            <h5 className="page-title"> {title} </h5>
            <div className="col-md-2 col-sm-3 col-2 d-flex justify-content-end"></div>
          </div>
          <div className="col-md-2 col-sm-3 col-2 col-lg-2">
            <div className="row justify-content-end">
              <button
                onClick={handleStartTourClick}
                className="start-tour-button"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                {isHovered ? (
                  <>
                    {menuItemsStrings.tourParamsTourStartButton}
                    <FontAwesomeIcon icon="circle-play" className="ml-2" />
                  </>
                ) : (
                  <FontAwesomeIcon icon="circle-play" />
                )}
              </button>
              <span className="tour-homepage-help-popup">
                <QlikObject
                  id="a247eac6-ac8e-41e5-bc7c-aca4c94026e8"
                  height="30px"
                  showLoader={false}
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-start">
        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
          <QlikObject id="a49c567e-5174-4fbc-8463-a0e7a6a4ce20" height="30px" showLoader={false} />
        </div>
        <div className="col-xs-13 col-sm-6 col-md-4 col-lg-4">
          <QlikObject id="NYxkAp" height="40px" showLoader={false} />
        </div>
      </div>

      <div className="container-fluid">
        <div className="row justify-content-start tour-home-kpi-row">
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2">
            {/* income */}
            <QlikCard id="JPhjmJ" height="210px" showHeader={false} showMaximize={false} showExport={false} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 tour-home-kpi-financial-coverage">
            {/* min sell value */}
            <QlikCard id="LYPcmTX" height="210px" showHeader={false} showMaximize={false} showExport={false} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2">
            {/* no of auctions */}
            <QlikCard id="EcJXFmb" height="210px" showHeader={false} showMaximize={false} showExport={false} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2">
            {/* KPI4 */}
            <QlikCard id="pGXWV" height="210px" showHeader={false} showMaximize={false} showExport={false} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2">
            {/* KPI5 */}
            <QlikCard id="rxjk" height="210px" showHeader={false} showMaximize={false} showExport={false} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2">
            {/* bids per auction */}
            <QlikCard id="zCav" height="210px" showHeader={false} showMaximize={false} showExport={false} />
          </div>
        </div>

        <div className="row justify-content-left">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <QlikCard id="SapGGmv" height="56px" showHeader={false} showMaximize={false} showExport={false} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <QlikCard id="CPmkTg" height="56px" showHeader={false} showMaximize={false} showExport={false} />
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 ">
            {/* vizCAVClassMain */}
            <QlikCard id="63168c64-e393-48dc-abcd-51dedbb3dc15" height="320px" showHeader={true} showMaximize={true} showExport={false} />
          </div>
          {/* vizOwnerMain */}
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 tour-home-barchart">
            <QlikCard id="gTZDmAE" height="320px" showHeader={true} showMaximize={true} showExport={false} />
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            {/* vizDynamiscMain */}
            <QlikCard id="f9533367-95fb-47a1-a8a2-90601edb3386" height="320px" showHeader={true} showMaximize={true} showExport={false} />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject id="JMqrBrm" height="0px" showLoader={false} />
          </div>
        </div>
      </div>
    </section>
  );
}
